export interface LoginSearch {
  tenant?: string;
  redirect?: string;
}

export function loginSearchSchema(search: Record<string, unknown>): LoginSearch {
  return {
    ...(typeof search.tenant === 'string' && search.tenant ? { tenant: search.tenant } : {}),
    ...(typeof search.redirect === 'string' && search.redirect ? { redirect: search.redirect } : {}),
  };
}

/** Only allow same-origin, path-absolute redirects. */
export function safeRedirect(target: string | undefined): string {
  if (!target || !target.startsWith('/') || target.startsWith('//') || target.startsWith('/login'))
    return '/';
  return target;
}
